import { makeObservable, observable, action, runInAction } from "mobx";
import { MrbBaseViewStore } from "mrb/core";
import { localizationService } from "common/localization";

class CertifierContentItemViewStore extends MrbBaseViewStore {
    @observable isUpdating = false;

    constructor(rootStore, { contentListViewStore }) {
        super(rootStore);
        makeObservable(this);
        this.contentListViewStore = contentListViewStore;
        this.routeStore = contentListViewStore.routeStore;
    }

    @action.bound
    async toggleApproval(item, value) {
        const isRejectingApproved = !value && item.isApproved;

        if (isRejectingApproved) {
            this.rootStore.confirmDialogStore.showConfirm({
                message: localizationService.t("APPLICATION.CERTIFIER.DASHBOARD.CONFIRM_REJECT"),
                onConfirm: async () => {
                    await this._performToggle(item, value);
                },
                yesLabel: "Yes",
                noLabel: "No",
            });
        } else {
            await this._performToggle(item, value);
        }
    }

    async _performToggle(item, value) {
        const oldApproved = item.isApproved;
        const oldPending = item.isPending;

        runInAction(() => {
            item.isApproved = value;
            item.isPending = false;
            this.isUpdating = true;
        });

        try {
            await this.routeStore.updateContentStatus(
                this.contentListViewStore.dashboardViewStore.selectedModeId,
                item.id,
                value
            );
            this.contentListViewStore.dashboardViewStore.fetchSummary();
        } catch (err) {
            runInAction(() => {
                item.isApproved = oldApproved;
                item.isPending = oldPending;
            });
            this.rootStore.notificationStore.error(
                localizationService.t("APPLICATION.CERTIFIER.DASHBOARD.NOTIFICATIONS.STATUS_UPDATE_ERROR"),
                err
            );
        } finally {
            runInAction(() => {
                this.isUpdating = false;
            });
        }
    }
}

export default CertifierContentItemViewStore;
